import gameConfigurations from '../theme/config';

export const useDevTools = process.env.REACT_APP_ENABLE_DEV_TOOLS === 'true';
export const devTools = {
  log: (message?: any, ...optionalParams: any[]) => {
    if (!useDevTools) return;
    console.log(message, ...optionalParams);
  },

  getPredictorIdViaUrl: () => {
    const searchParams = new URLSearchParams(document.location.search);
    const predictorId = searchParams.get(gameConfigurations.predictorIdIdentifier) || searchParams.get('predictorId');
    if (predictorId) return parseInt(predictorId);
  },
};

export type DeepPartial<Object> = Object extends object
  ? {
      [Key in keyof Object]?: DeepPartial<Object[Key]>;
    }
  : Object;
